import Grid2 from "@mui/material/Unstable_Grid2";
import SteddiButton from "../General/SteddiButton";
import * as React from "react";
import {Box} from "@mui/material";
import PageHeader from "../General/PageHeader";
import NiceModal from "@ebay/nice-modal-react";
import CancelDialog from "../Esign/Steps/CancelDialog";
import {getPaymentFreeData, updatePaymentFreeMonths} from "../../api/SignRequests";
import {getRedirectUrl, parseEndpointError} from "../../helpers/orderHelpers";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import useErrorStore from "../../stores/errorStore";
import {useEffect, useState} from "react";
import useOrderState from "../../stores/orderStore";
import {ReactComponent as CompleteIcon} from "../../images/Bestilling.svg"
import LoadingPage from "../Esign/Steps/LoadingPage";
import PaymentFreePage from "./Steps/PaymentFreePage";
import PaymentFreeCompletedPage from "./Steps/PaymentFreeCompletedPage";
import useAppState from "../../stores/appStateStore";
import enumFromName from "../../helpers/BrandParser";
import BrandEnum from "../../types/BrandEnum";

export default function PaymentFreeWrapper() {
  let {hashId} = useParams<string>()
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate()

  const orderState = useOrderState((state) => state)
  const setError = useErrorStore((state) => state.setError)
  const error = useErrorStore((state) => state.error)
  const goNextDisabled = useAppState((state) => state.goNextDisabled)
  const goNextTooltip = useAppState((state) => state.goNextTooltip)
  const setRedirectBrand = useAppState((state) => state.setRedirectBrand)
  const redirectBrand = useAppState((state) => state.redirectBrand)

  const [activeStep, setActiveStep] = React.useState(0);
  const [cancelProcessStarted, setCancelProcessStarted] = React.useState(false);
  const [orderLoading, setOrderLoading] = useState(true)

  function handleCancel() {
    NiceModal.show(CancelDialog)
  }

  useEffect(() => {
    document.title = "Steddi - Betalingsfrie måneder"
  }, [])

  useEffect(() => {
    try {
      const brandString = searchParams.get("brand")
      if(brandString != null) {
        const brand = enumFromName(brandString, BrandEnum)
        setRedirectBrand(brand)
      }
    } catch(e){
      console.log("Could not parse brand")
      console.log(e)
      setRedirectBrand(BrandEnum.Unknown)
    }
  }, [searchParams])

  useEffect(() => {
    if (hashId) {
      setOrderLoading(true)
      getPaymentFreeData(hashId!)
        .then(account => {
          orderState.setPaymentFreeMonthData(account)
        })
        .catch(err => {
          setError(parseEndpointError(err))
        })
        .finally(() => setOrderLoading(false))
    }
  }, [hashId])

  function handleUpdatePaymentFree() {
    if (hashId) {
      setCancelProcessStarted(true)

      updatePaymentFreeMonths(hashId, orderState.paymentFreeMonths)
        .then(() => {
          handleNext()
        }).catch(err => {
        setError(parseEndpointError(err))
      })
    }
  }

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    window.scrollTo({ top: 0, left: 0 });
  };

  const handleDone = () => {
    window.location.href = getRedirectUrl(redirectBrand)
  };

  const steps = [
    {title: "Betalingsfri måned", element: <PaymentFreePage/>, image: null},
    {title: "Endringen er lagret", element: <PaymentFreeCompletedPage/>, image: <CompleteIcon/>},
  ]

  useEffect(() => {
    if (error)
      navigate("error")
  }, [error])

  function getStepButtons() {
    return (
      <Grid2 container mt={5} spacing={2} justifyContent="space-between">
        <Grid2 xs={12} sm={"auto"}></Grid2>

        <Grid2 xs={12} sm={"auto"} container justifyContent="flex-end" spacing={2}>
          <Grid2 xs={12} sm="auto" hidden={activeStep > 0} sx={{display: {xs: "none", sm: "block"}}}>
            {activeStep === 0 && <SteddiButton variant="outlined" onClick={handleCancel} disabled={cancelProcessStarted}>Avbryt</SteddiButton>}
          </Grid2>
          <Grid2 xs={12} sm="auto">
            {activeStep > 0 ?
              <SteddiButton onClick={handleDone}>Ferdig</SteddiButton> :
              <SteddiButton onClick={handleUpdatePaymentFree} disabled={cancelProcessStarted || goNextDisabled} tooltip={goNextDisabled ? goNextTooltip : undefined} loading={cancelProcessStarted}>Lagre</SteddiButton>}
          </Grid2>
        </Grid2>

      </Grid2>
    )
  }

  if (orderLoading) {
    return (
      <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <LoadingPage/>
      </Box>
    )
  }

  return (
    <>
      <Box pt={5}>
        <Box display="flex" justifyContent="flex-end">
          {activeStep === 0 && <SteddiButton variant="text" onClick={handleCancel} onlyShowXs noShrink sx={{mb: 3}} disabled={cancelProcessStarted}>Avbryt</SteddiButton>}
        </Box>
        {steps[activeStep].image && <Box display="flex" alignItems="center" justifyContent="center" mb={5}>{steps[activeStep].image}</Box>}
        <PageHeader>{steps[activeStep].title}</PageHeader>
        {steps[activeStep].element}
      </Box>
      {getStepButtons()}
    </>
  )
}